export enum UserRole {
  Admin = 1,
  Manager = 2,
  PowerUse = 3,
  Sales = 4,
  VR = 5,
}

export enum UserRoleName {
  Admin = "admin",
  Manager = "manager",
  PowerUse = "power use",
  Sales = "sales",
  VR = "VR",
}

export function getRoleById(roleName: string) {
  return UserRole[roleName as keyof typeof UserRole];
}
